const getAPIBaseURL = () => {
  console.log("Current ENVIRONMENT:", process.env.REACT_APP_ENVIRONMENT);

  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "local":
      return process.env.REACT_APP_API_BASE_URL_LOCAL || "http://localhost:3001/api";

    case "staging":
      return process.env.REACT_APP_API_BASE_URL_STAGING || "https://staging.neochat.io/api";

    case "production":
      return process.env.REACT_APP_API_BASE_URL_PRODUCTION || "https://api.neochat.io/api";

    default:
      console.warn("Unknown ENVIRONMENT, defaulting to local API URL");
      return "http://localhost:3001/api"; // Fallback to local
  }
};


const config = {
  // API base URL
  API_BASE_URL: getAPIBaseURL(),
  
  // Authentication endpoints
  AUTH_ENDPOINTS: {
    SIGNUP: '/auth/signup',
    LOGIN: '/auth/login',
    ME: '/auth/me',
    UPDATE_PASSWORD: '/auth/update-password',
    UPDATE_PROFILE: '/auth/update-me',
    UPDATE_SUBSCRIPTION: '/auth/update-subscription',
  },
  
  // Admin endpoints
  ADMIN_ENDPOINTS: {
    CHECK_EXISTS: '/admin/check-exists',
    REGISTER_FIRST: '/admin/register-first',
    LOGIN: '/admin/login',
    ME: '/admin/me',
    UPDATE_PASSWORD: '/admin/update-password',
    UPDATE_PROFILE: '/admin/update-me',
    DASHBOARD_STATS: '/admin/dashboard/stats',
    USERS: '/admin/users',
    USER_DETAILS: (userId) => `/admin/users/${userId}`,
    UPDATE_USER: (userId) => `/admin/users/${userId}`,
    USER_PROJECTS: (userId) => `/admin/users/${userId}/projects`,
  },
  
  // Project endpoints
  PROJECT_ENDPOINTS: {
    ALL: '/projects',
    DETAILS: id => `/projects/${id}`,
    DETAIL: id => `/projects/${id}`, // Alias for DETAILS to fix getSDKConfig
    API_KEY: id => `/projects/${id}/api-key`,
    REGENERATE_API_KEY: id => `/projects/${id}/regenerate-api-key`,
    SETTINGS: id => `/projects/${id}/settings`,
    SYNC_TO_PRODUCTION: id => `/projects/${id}/sync-to-production`,
    
    // API endpoints
    API_ENDPOINTS: {
      ALL: projectId => `/projects/${projectId}/api-endpoints`,
      DETAILS: (projectId, endpointId) => `/projects/${projectId}/api-endpoints/${endpointId}`,
      TEST: (projectId, endpointId) => `/projects/${projectId}/api-endpoints/${endpointId}/test`,
      GENERATE_EXAMPLE: (projectId, endpointId) => `/projects/${projectId}/api-endpoints/${endpointId}/generate-example`,
      SYNC_TO_PRODUCTION: (projectId, endpointId) => `/projects/${projectId}/api-endpoints/${endpointId}/sync-to-production`,
    },
    
    // SDK endpoints
    SDK: {
      CONFIG: projectId => `/projects/${projectId}/sdk-config`,
      SCRIPT: projectId => `/sdk/projects/${projectId}/sdk`,
    },
    
    // Knowledge Base endpoints
    KNOWLEDGE_BASE: {
      DOCUMENTS: {
        ALL: (projectId) => `/projects/${projectId}/knowledge-base/documents`,
        DETAILS: (projectId, documentId) => `/projects/${projectId}/knowledge-base/documents/${documentId}`,
        UPLOAD: (projectId) => `/projects/${projectId}/knowledge-base/documents/upload`,
        TEXT: (projectId) => `/projects/${projectId}/knowledge-base/documents/text`,
        SCRAPE: (projectId) => `/projects/${projectId}/knowledge-base/documents/scrape`,
        TEST_API: (projectId) => `/projects/${projectId}/knowledge-base/documents/test-api`,
        SCRAPE_API: (projectId) => `/projects/${projectId}/knowledge-base/documents/scrape-api`,
        RESCRAPE_API: (projectId, documentId) => `/projects/${projectId}/knowledge-base/documents/${documentId}/rescrape-api`,
      },
      SEARCH: (projectId) => `/projects/${projectId}/knowledge-base/search`,
    },
    
    // Chatbot endpoints
    CHATBOT: {
      SDK: {
        CONFIG: (projectId) => `/projects/${projectId}/chatbot/sdk-config`,
      },
    },
  },
  
  // Analytics endpoints
  ANALYTICS_ENDPOINTS: {
    STATS: (projectId) => `/analytics/projects/${projectId}/stats`,
    REPORT: (projectId) => `/analytics/projects/${projectId}/report`,
  },
  
  // Chatbot endpoints
  CHATBOT_ENDPOINTS: {
    MESSAGE: '/chatbot/sdk/message',
    END_SESSION: '/chatbot/sdk/end',
    INIT_SESSION: '/chatbot/sdk/init',
    COST: '/chatbot/protected/cost',
    SESSIONS: '/chatbot/admin/sessions',
    AGGREGATE_SESSIONS: '/chatbot/admin/aggregate-sessions',
    MONTHLY_SESSIONS: '/chatbot/admin/monthlySessions',
    HISTORY: id => `/chatbot/admin/sessions/${id}`,
  },
  
  // Knowledge base endpoints
  KNOWLEDGE_BASE_ENDPOINTS: {
    ALL: '/knowledge-base',
    DETAILS: id => `/knowledge-base/${id}`,
    SEARCH: '/knowledge-base/search',
  },
  
  // Authentication methods
  AUTH_METHODS: {
    JWT: 'jwt',
    API_KEY: 'apiKey',
    WHATSAPP: 'whatsapp',
    TELEGRAM: 'telegram',
    NONE: 'none',
  },
  
  // User roles
  USER_ROLES: {
    ADMIN: 'admin',
    CLIENT: 'client',
    USER: 'user',
  },
  
  // Pagination defaults
  PAGINATION: {
    PAGE_SIZE: 10,
  },
};

export default config; 